// Generated by psc version 0.10.2
"use strict";
var $foreign = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-partial/src/Partial/Unsafe.js");
var Partial = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-partial/src/Partial.purs");
var unsafeCrashWith = function (msg) {
    return $foreign.unsafePartial(function (dictPartial) {
        return Partial.crashWith(dictPartial)(msg);
    });
};
module.exports = {
    unsafeCrashWith: unsafeCrashWith, 
    unsafePartial: $foreign.unsafePartial
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-partial/src/Partial/Unsafe.purs
// module id = 36
// module chunks = 0